import molin_2 from '../../assets/images/tra/molin_2.webp';
import molin_3 from '../../assets/images/tra/molin_3.webp';
import MolinHeader from '../../components/MolinHeader';
import { useState } from 'react';
import '../../styles/common.css'
export default function MarinaDistrict() {
    const [storyStatus, setStoryStatus] = useState(0);
    return (
        <div className="relative">
            <MolinHeader></MolinHeader>

            {storyStatus < 1 && (
                <img src={molin_2} alt="Hero background" className="w-full h-auto" />
            )}
            {storyStatus >= 1 && (
                <img src={molin_3} alt="Hero background" className="w-full h-auto" />
            )}
            <div className='absolute bottom-[30%] left-[55%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110'>
                <div className="flex flex-col text-center font-bold">
                    <span className="text-[#000000] text-[1vw]">项元汴</span>
                    <span className="text-[#000000] text-[0.8vw]">Xiang Yuanbian</span>
                </div>
            </div>
            {storyStatus === 0 && (
                <div className="top-[48%] left-[43%] absolute">
                    <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                        onClick={() => setStoryStatus(1)}>
                    </button>
                </div>
            )}
            {storyStatus === 1 && (
                <div className="top-[48%] left-[36%] absolute">
                    <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                        onClick={() => setStoryStatus(2)}>
                    </button>
                </div>
            )}
            {storyStatus >= 1 && (
                <div className={`chat-bubble-base absolute top-[30%] left-[76%] transform -translate-x-1/2 chat-bubble-left 
                    chat-bubble-fade-in ${storyStatus >= 1 ? 'chat-bubble-fade-in-active' : ''}`}>
                    <span className='mt-[1vw] typing-effect'>嗯……釉色如冰，胎质细腻，官窑无疑。</span>
                    <span className='mb-[1vw] typing-effect'>Well ...... glaze like ice, the tyre is delicate, official kiln undoubtedly.</span>
                </div>
            )}
            {storyStatus >= 2 && (
                <div className={`chat-bubble-base absolute top-[40%] left-[31%] transform -translate-x-1/2 chat-bubble-right
                    chat-bubble-fade-in ${storyStatus >= 1 ? 'chat-bubble-fade-in-active' : ''}`}>
                    <span className='mt-[1vw] typing-effect'>客官好眼力！</span>
                    <span className='mb-[1vw] typing-effect'>You have a good eye, sir!</span>
                </div>
            )}
        </div>
    )
}